import React from 'react';
import { 
  MessageSquare, 
  HelpCircle, 
  GitBranch, 
  ArrowRight, 
  Globe, 
  Clock, 
  Zap,
  StopCircle
} from 'lucide-react';

export const NodePalette: React.FC = () => {
  const onDragStart = (event: React.DragEvent, nodeType: string) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="w-64 bg-white border-r overflow-y-auto shadow-sm">
      <div className="p-4">
        <h2 className="text-sm font-semibold text-gray-900 mb-4">
          Elementos del Flujo
        </h2>
        <div className="space-y-2">
          <div
            draggable
            onDragStart={(e) => onDragStart(e, 'trigger')}
            className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-grab active:cursor-grabbing"
          >
            <Zap className="h-5 w-5 mr-3 text-blue-500" />
            <div className="flex flex-col items-start">
              <span className="font-medium">Disparador</span>
              <span className="text-xs text-gray-500">Inicia el flujo</span>
            </div>
          </div>

          <div
            draggable
            onDragStart={(e) => onDragStart(e, 'sendMessage')}
            className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-grab active:cursor-grabbing"
          >
            <MessageSquare className="h-5 w-5 mr-3 text-emerald-500" />
            <div className="flex flex-col items-start">
              <span className="font-medium">Enviar Mensaje</span>
              <span className="text-xs text-gray-500">Envía texto o multimedia</span>
            </div>
          </div>

          <div
            draggable
            onDragStart={(e) => onDragStart(e, 'askQuestion')}
            className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-grab active:cursor-grabbing"
          >
            <HelpCircle className="h-5 w-5 mr-3 text-indigo-500" />
            <div className="flex flex-col items-start">
              <span className="font-medium">Hacer Pregunta</span>
              <span className="text-xs text-gray-500">Espera respuesta del usuario</span>
            </div>
          </div>

          <div
            draggable
            onDragStart={(e) => onDragStart(e, 'branch')}
            className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-grab active:cursor-grabbing"
          >
            <GitBranch className="h-5 w-5 mr-3 text-amber-500" />
            <div className="flex flex-col items-start">
              <span className="font-medium">Rama</span>
              <span className="text-xs text-gray-500">Crea condiciones</span>
            </div>
          </div>

          <div
            draggable
            onDragStart={(e) => onDragStart(e, 'jump')}
            className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-grab active:cursor-grabbing"
          >
            <ArrowRight className="h-5 w-5 mr-3 text-red-500" />
            <div className="flex flex-col items-start">
              <span className="font-medium">Saltar</span>
              <span className="text-xs text-gray-500">Ir a otro paso</span>
            </div>
          </div>

          <div
            draggable
            onDragStart={(e) => onDragStart(e, 'httpRequest')}
            className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-grab active:cursor-grabbing"
          >
            <Globe className="h-5 w-5 mr-3 text-purple-500" />
            <div className="flex flex-col items-start">
              <span className="font-medium">Petición HTTP</span>
              <span className="text-xs text-gray-500">Conecta con APIs externas</span>
            </div>
          </div>

          <div
            draggable
            onDragStart={(e) => onDragStart(e, 'waitForResponse')}
            className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-grab active:cursor-grabbing"
          >
            <Clock className="h-5 w-5 mr-3 text-pink-500" />
            <div className="flex flex-col items-start">
              <span className="font-medium">Esperar Respuesta</span>
              <span className="text-xs text-gray-500">Pausa el flujo</span>
            </div>
          </div>

          <div
            draggable
            onDragStart={(e) => onDragStart(e, 'end')}
            className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-grab active:cursor-grabbing"
          >
            <StopCircle className="h-5 w-5 mr-3 text-gray-500" />
            <div className="flex flex-col items-start">
              <span className="font-medium">Finalizar</span>
              <span className="text-xs text-gray-500">Termina la conversación</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};